import React, { useState } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (

    <header className="fixed top-0 left-0 w-full bg-[#071B34] shadow-lg z-50">

      <div className="max-w-7xl mx-auto px-8">

        <div className="flex justify-between items-center h-20">

          {/* Logo */}

          <div className="flex items-center gap-4">

            <img
              src="/eforum_logo.png"
              alt="E-Forum"
              className="h-14"
            />

            <div>

              <h1 className="text-white text-3xl font-bold">
                E-FORUM
              </h1>

            </div>

          </div>

          {/* Desktop Navigation */}

          <nav className="hidden lg:flex items-center gap-8 text-[15px] font-medium">

            {/* Home */}

      <Link
  to="/"
  className="text-white hover:text-blue-400 transition"
>
  Home
</Link>
            {/* Services */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                Services

                <FaChevronDown size={10} />

              </button>

        <div className="absolute left-0 top-full hidden group-hover:block w-72 rounded-xl bg-white shadow-xl">
  <Link
    to="/services/product-development"
    className="block px-5 py-3 hover:bg-blue-50"
  >
    Product Development
  </Link>

  <Link
    to="/services/product-maintenance"
    className="block px-5 py-3 hover:bg-blue-50"
  >
    Product Maintenance
  </Link>

  <Link
    to="/services/it-staffing"
    className="block px-5 py-3 hover:bg-blue-50"
  >
    IT Staffing
  </Link>

  <Link
    to="/services/training"
    className="block px-5 py-3 hover:bg-blue-50"
  >
    Training
  </Link>

  <Link
    to="/services/managed-it-services"
    className="block px-5 py-3 hover:bg-blue-50"
  >
    Managed IT Services
  </Link>

</div>
            </div>

            {/* Technology */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                Technology

                <FaChevronDown size={10} />

              </button>

              <div className="absolute hidden group-hover:block mt-4 w-64 rounded-xl bg-white shadow-xl overflow-hidden">

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Frontend
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Backend
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Mobile
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Cloud
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  AI / ML
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  DevOps
                </a>

              </div>

            </div>

            {/* Industries */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                Industries

                <FaChevronDown size={10} />

              </button>

              <div className="absolute hidden group-hover:block mt-4 w-64 rounded-xl bg-white shadow-xl overflow-hidden">

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Healthcare
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Manufacturing
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Retail
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Finance
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Education
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Logistics
                </a>

              </div>

            </div>

            {/* Resources */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                Resources

                <FaChevronDown size={10} />

              </button>

              <div className="absolute hidden group-hover:block mt-4 w-64 rounded-xl bg-white shadow-xl overflow-hidden">

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Blogs
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Case Studies
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  FAQs
                </a>

              </div>

            </div>
                        {/* Careers */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                Careers

                <FaChevronDown size={10} />

              </button>

              <div className="absolute hidden group-hover:block mt-4 w-64 rounded-xl bg-white shadow-xl overflow-hidden">

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Jobs
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Internships
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Life @ E-Forum
                </a>

              </div>

            </div>

            {/* About Us */}

            <div className="relative group">

              <button className="flex items-center gap-1 text-white hover:text-blue-400 transition">

                About Us

                <FaChevronDown size={10} />

              </button>

              <div className="absolute hidden group-hover:block mt-4 w-64 rounded-xl bg-white shadow-xl overflow-hidden">

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Company Overview
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Vision & Mission
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Leadership
                </a>

                <a className="block px-5 py-3 hover:bg-blue-50">
                  Contact Us
                </a>

              </div>

            </div>

          </nav>

          {/* Mobile Menu Button */}

          <button
            className="lg:hidden text-white text-3xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>

        </div>


      </div>
      {/* Mobile Navigation */}

      {menuOpen && (

        <div className="lg:hidden bg-[#071B34] border-t border-blue-900">

          {/* Home */}

          <a
            href="#"
            className="block px-8 py-4 text-white border-b border-blue-900"
          >
            Home
          </a>

          {/* Services */}

          <details className="border-b border-blue-900">

            <summary className="px-8 py-4 text-white cursor-pointer">
              Services
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Product Development
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Product Maintenance
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                IT Staffing
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Training
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Managed IT Services
              </a>

            </div>

          </details>

          {/* Technology */}

          <details className="border-b border-blue-900">

            <summary className="px-8 py-4 text-white cursor-pointer">
              Technology
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Frontend
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Backend
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Mobile
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Cloud
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                AI / ML
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                DevOps
              </a>

            </div>

          </details>

          {/* Industries */}

          <details className="border-b border-blue-900">

            <summary className="px-8 py-4 text-white cursor-pointer">
              Industries
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Healthcare
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Manufacturing
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Retail
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Finance
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Education
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Logistics
              </a>

            </div>

          </details>

          {/* Resources */}

          <details className="border-b border-blue-900">

            <summary className="px-8 py-4 text-white cursor-pointer">
              Resources
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Blogs
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Case Studies
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                FAQs
              </a>

            </div>

          </details>

          {/* Careers */}

          <details className="border-b border-blue-900">

            <summary className="px-8 py-4 text-white cursor-pointer">
              Careers
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Jobs
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Internships
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Life @ E-Forum
              </a>

            </div>

          </details>

          {/* About Us */}

          <details>

            <summary className="px-8 py-4 text-white cursor-pointer">
              About Us
            </summary>

            <div className="bg-[#0B2545]">

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Company Overview
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Vision & Mission
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Leadership
              </a>

              <a className="block px-12 py-3 text-gray-300 hover:text-white">
                Contact Us
              </a>

            </div>

          </details>

        </div>

      )}
    </header>

  );

}